import { render, staticRenderFns } from "./Item-table.vue?vue&type=template&id=26ae0928&scoped=true&lang=en"
import script from "./Item-table.vue?vue&type=script&lang=js"
export * from "./Item-table.vue?vue&type=script&lang=js"
import style0 from "./Item-table.vue?vue&type=style&index=0&id=26ae0928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ae0928",
  null
  
)

export default component.exports